<div class="rms-stepper" [class.vertical]="orientation === 'vertical'">
  <!-- Headers -->
  <ol class="rms-stepper-header"
      role="tablist"
      [attr.aria-orientation]="orientation">
    <li *ngFor="let step of stepList; let i = index"
        class="rms-step-header-item"
        [class.active]="i === activeIndex()"
        [class.complete]="isComplete(i)"
        [class.invalid]="isError(i)"
        [class.disabled]="!canGoTo(i)">
      <button type="button"
              class="rms-step-header"
              role="tab"
              [attr.aria-selected]="i === activeIndex()"
              [attr.aria-controls]="'rms-step-panel-' + i"
              [attr.id]="'rms-step-' + i"
              [disabled]="!canGoTo(i)"
              (click)="onHeaderClick(i)"
              (keydown)="onHeaderKeydown($event, i)">
        <span class="circle" [attr.aria-hidden]="true">
          <mat-icon *ngIf="isComplete(i)">check</mat-icon>
          <span *ngIf="!isComplete(i)">{{ i + 1 }}</span>
        </span>
        <span class="labels">
          <span class="label">{{ step.label }}</span>
          <span class="subtitle" *ngIf="step.subtitle">{{ step.subtitle }}</span>
          <span class="error" *ngIf="isError(i) && step.error">{{ step.error }}</span>
        </span>
      </button>
      <span class="connector" *ngIf="orientation === 'horizontal' && i < stepList.length - 1"></span>
    </li>
  </ol>

  <!-- Optional progress bar -->
  <div class="rms-stepper-progress" *ngIf="showProgress">
    <div class="bar" [style.width.%]="progressPct()"></div>
  </div>

  <!-- Active content -->
  <section class="rms-stepper-contents">
    <ng-container *ngFor="let step of stepList; let i = index">
      <div class="rms-step-panel"
           role="tabpanel"
           [attr.aria-labelledby]="'rms-step-' + i"
           [attr.id]="'rms-step-panel-' + i"
           [hidden]="i !== activeIndex()">
        <!-- RMS fieldset wrapper to match your inputs -->
        <fieldset [ngClass]="{'no-margin': true}"
                  [class.invalid]="isError(i)"
                  [style.background]="backgroundColor">
          <legend>{{ step.label }}</legend>
          <ng-container *ngTemplateOutlet="step.template"></ng-container>
        </fieldset>

        <!-- Actions -->
        <div class="rms-step-actions">
          <button type="button" class="rms-btn secondary" (click)="prev()" [disabled]="activeIndex() === 0">{{ prevText }}</button>
          <div class="spacer"></div>
          <button type="button" class="rms-btn"
                  *ngIf="!isLast()"
                  (click)="next()"
                  [disabled]="linear && !currentCanAdvance()">
            {{ nextText }}
          </button>
          <button type="button" class="rms-btn primary"
                  *ngIf="isLast()"
                  (click)="finish()"
                  [disabled]="linear && !allValid()">
            {{ finishText }}
          </button>
        </div>
      </div>
    </ng-container>
  </section>
</div>
